import React, { useState } from "react";

// import "./LineupDrop.scss";
import NextImage from "../NextImage";

export default function LineupBox({ children, title, titleImg }) {
  const [isOpen, setIsOpen] = useState(true);

  return (
    <div className={`lineup_box_drop ${isOpen ? "open_dropdown" : ""}`}>
      <span className="lineup_box_opener" onClick={() => setIsOpen(!isOpen)}>
        {titleImg && (
          <div className="icon_wrap">
            <NextImage src={titleImg} width={18} height={18} alt="avatar" />
          </div>
        )}
        {title}
      </span>
      {isOpen && <div className="inner_lineup">{children}</div>}
    </div>
  );
}
